import { merchantApi } from '@/config/axios'

/**
 * 商家端 - 类目申请 API
 */

// 获取平台全量商品分类（树形，用于选择经营类目）
export const getPlatformCategoryTree = () => {
  return merchantApi.get({ url: '/merchant-api/merchant/shop-category/platform-category-tree' })
}

// 获取类目申请记录
export const getApplyList = () => {
  return merchantApi.get({ url: '/merchant-api/merchant/shop-category/apply-list' })
}

// 提交类目申请（支持批量）
export const submitApply = (data: {
  items: Array<{
    categoryId: number
    categoryName: string
    parentCategoryName: string
  }>
}) => {
  return merchantApi.post({ url: '/merchant-api/merchant/shop-category/submit-apply', data })
}
